import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const SCHOOL_ROLES = ["admin", "teacher", "student", "parent"];

export default function LoginPage() {
  const { login, user, SCHOOL_SYSTEM_URL } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Already logged in — redirect immediately
  if (user) {
    if (user.role === "webAdmin") return <Navigate to="/admin-dashboard" replace />;
    if (SCHOOL_ROLES.includes(user.role)) { window.location.href = SCHOOL_SYSTEM_URL; return null; }
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      if (user.role === "webAdmin") {
        navigate("/admin-dashboard", { replace: true });
      } else if (SCHOOL_ROLES.includes(user.role)) {
        window.location.href = SCHOOL_SYSTEM_URL;
      } else {
        navigate("/", { replace: true });
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <header className="page__hero">
        <h1>Portal Login</h1>
        <p>Sign in to access your dashboard</p>
      </header>

      <section className="section">
        <div className="section__inner">
          <div className="login-card">
            <h2>Sign In</h2>

            {error && <p className="login-card__error">{error}</p>}

            <form onSubmit={handleSubmit} className="login-form" noValidate>
              <label className="login-form__label">
                Email
                <input
                  type="email"
                  className="login-form__input"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  required
                  autoComplete="email"
                  placeholder="you@mokorotlocollege.co.ls"
                />
              </label>

              <label className="login-form__label">
                Password
                <input
                  type="password"
                  className="login-form__input"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  required
                  autoComplete="current-password"
                  placeholder="••••••••"
                />
              </label>

              <button
                type="submit"
                className="btn btn--accent btn--lg"
                disabled={loading}
                style={{ width: "100%", justifyContent: "center", marginTop: 8 }}
              >
                {loading ? "Signing in…" : "Sign In"}
              </button>
            </form>

            <p className="login-card__help">
              Need help?{" "}
              <a href="mailto:college@mokorotlocollege.co.ls">Contact support</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
